import { useAction, useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { Array } from '@blade/std-lib'
import { recentSearchesModelAtom } from '@root/features/user/recent-searches'

import { TopbarError } from '../common/topbar-error'
import { TopbarPairItemSkeleton } from '../common/topbar-pair-item-skeleton'

import { TopbarRecentSearchList } from './topbar-recent-serach-list'

export const TopbarRecentSearch: React.FC = () => {
  const [model] = useAtom(recentSearchesModelAtom)
  const [recentSearchesState] = useAtom(model.recentSearchesAtom)
  const loadRecentSearchPairs = useAction(model.recentSearchesAtom.execute)

  const handleReload = () => loadRecentSearchPairs()

  return (
    <Root>
      {AsyncStateN.matchWaiting(recentSearchesState, {
        Success: (recentSearchPairs) => {
          if (recentSearchPairs.length === 0) {
            return <TopbarError onReload={handleReload} intent="empty" />
          }

          return (
            <TopbarRecentSearchList recentSearchPairs={recentSearchPairs} />
          )
        },
        Error: () => <TopbarError onReload={handleReload} />,
        Waiting: () => (
          <List>
            {Array.range(0, 2).map((x) => (
              <SkeletonItem key={x}>
                <TopbarPairItemSkeleton />
              </SkeletonItem>
            ))}
          </List>
        ),
      })}
    </Root>
  )
}

const Root = styled.div``

const List = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
`

const SkeletonItem = styled.div`
  padding: 0 5px;
`
